<style lang="scss">
@import "../styles/payment-v2/payment-menu-content-form-bank-transfer.scss";
@import "@/styles/_mixins.scss";
.form-offset-right {
  padding-right: 0;
  @include tablet {
    padding-right: 16px;
  }
}
</style>

<template>
  <v-form
    v-if="paymentMethodSelected === 'bank_transfer' || paymentMethodSelected === 'pay_now'"
    ref="form"
    class="payment-menu-content-form-bank-transfer"
    @submit.prevent="onClickSubmitPayment"
  >
    <v-layout row wrap>
      <v-flex xs12 md12 class="payment-menu-content-form-bank-transfer-left-panel new-payment-ui-method">
        <div class="u-margin-bottom-medium">
          <div class="bank-content">
            <div v-if="paymentMethodSelected === 'bank_transfer'" class="content-note">
              Note: It may take 2 to 3 working days for your bank transfer to reach us.
            </div>

            <div v-if="paymentMethodSelected === 'bank_transfer'" class="content-info">
              Use the bank details below to make your payment from your bank's online banking or mobile app.
            </div>

            <div v-if="paymentMethodSelected === 'pay_now'" class="content-info">
              Use the PayNow details below to make your payment from your bank's online banking or mobile app.
            </div>

            <div class="content blued">
              Make sure you include <strong>{{ invoice.number }}</strong> in the Reference/Comments section. This is to
              help up identify your transaction.
            </div>
            <!--- ====================================== -->
            <!--- If User Select Payment Method  BANK TRANSFER -->
            <!--- ====================================== -->
            <div v-if="paymentMethodSelected === 'bank_transfer'" class="content-details">
              <div class="content-title">Sleek's bank details</div>

              <v-divider dark></v-divider>

              <div class="content-item">
                <div class="item-info">
                  <span>Recipient's name</span>
                  <h4>{{ bankDetails.account_name }}</h4>
                  <input type="hidden" id="account_name" :value="bankDetails.account_name" />
                </div>
                <copy-component :element_id="'account_name'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Bank</span>
                  <h4>{{ bankDetails.bank_name }}</h4>
                  <input type="hidden" id="bank_name" :value="bankDetails.bank_name" />
                </div>
                <copy-component :element_id="'bank_name'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Account number</span>
                  <h4>{{ bankDetails.account_number }}</h4>
                  <input type="hidden" id="account_number" :value="bankDetails.account_number" />
                </div>
                <copy-component :element_id="'account_number'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Swift code</span>
                  <h4>{{ bankDetails.swift_code }}</h4>
                  <input type="hidden" id="swift_code" :value="bankDetails.swift_code" />
                </div>
                <copy-component :element_id="'swift_code'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Amount to transfer</span>
                  <h4>{{ currency.symbol }}{{ Number(amountToTransfer).toLocaleString() }}</h4>
                  <input type="hidden" id="amountToTransfer" :value="amountToTransfer" />
                </div>
                <copy-component :element_id="'amountToTransfer'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Reference / Comments</span>
                  <h4>{{ invoice.number }}</h4>
                  <input type="hidden" id="invoice-number" :value="invoice.number" />
                </div>
                <copy-component :element_id="'invoice-number'" />
              </div>
            </div>

            <!--- ====================================== -->
            <!--- If User Select Payment Method  PAYNOW -->
            <!--- ====================================== -->

            <div v-if="paymentMethodSelected === 'pay_now'" class="content-details">
              <div class="content-title">PayNow details</div>
              <v-divider dark></v-divider>
              <div class="content-item">
                <div class="item-info">
                  <span>Unique Entity Number (UEN)</span>
                  <h4>{{ bankDetails.uen_paynow }}</h4>
                  <input type="hidden" id="uen_paynow" :value="bankDetails.uen_paynow" />
                </div>
                <copy-component :element_id="'uen_paynow'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Entity Name</span>
                  <h4>{{ bankDetails.account_name }}</h4>
                  <input type="hidden" id="account_name" :value="bankDetails.account_name" />
                </div>
                <copy-component :element_id="'account_name'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Amount to transfer</span>
                  <h4>{{ currency.symbol }}{{ Number(amountToTransfer).toLocaleString() }}</h4>
                  <input type="hidden" id="amountToTransfer" :value="amountToTransfer" />
                </div>
                <copy-component :element_id="'amountToTransfer'" />
              </div>
              <div class="content-item">
                <div class="item-info">
                  <span>Reference / Comments</span>
                  <h4>{{ invoice.number }}</h4>
                  <input type="hidden" id="invoice-number" :value="invoice.number" />
                </div>
                <copy-component :element_id="'invoice-number'" />
              </div>
              <v-divider dark></v-divider>
              <div class="content-item">
                <div class="qr-area">
                  <p style="margin: 0">Or scan our QR code if your banking app is from</p>
                  <a v-if="!show_supported_banks" href="#" @click="showSupportedBanks"
                    >one of these banks <v-icon color="primary" style="vertical-align: middle">expand_more</v-icon></a
                  >
                  <a v-if="show_supported_banks" href="#" @click="showSupportedBanks"
                    >one of these banks <v-icon color="primary" style="vertical-align: middle">expand_less</v-icon></a
                  >
                  <img
                    v-if="show_supported_banks"
                    style="width: 390px;position: absolute;left: -18px;top: 39px;"
                    src="/imgs/payment/supported-banks.jpg"
                  />
                  <img class="paynow-qr-img" src="/imgs/payment/paynow-qr.jpg" />
                  <p class="qr-footer">
                    Paying on mobile? Tap and save or take a screenshot of our QR code and upload it to your banking
                    app.
                  </p>
                </div>
              </div>
            </div>

            <v-btn :loading="isButtonLoading" color="primary" type="submit">
              <span class="text-uppercase font-weight-bold">I'VE MADE MY PAYMENT</span>
            </v-btn>
            <v-btn :loading="isButtonLoading" color="default" type="submit">
              <span class="text-uppercase font-weight-bold btn-pay-later">I'LL PAY LATER</span>
            </v-btn>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
/* eslint-disable */

// Proxies
import ApplyForManualPaymentProxy from "@/proxies/back-end/manual-payment/apply-for-external-payment";
import ApplyForSubscriptionManualPaymentProxy from "@/proxies/back-end/subscriptions/apply-for-external-payment";
import UserPreferenceByCompanyProxy from "@/proxies/back-end/users/user-preference-by-company";
import AllTypePaymentPostProxy from "@/proxies/back-end/subscriptions/payment-all-type";
import UpdatePaymentRequestByTokenProxy from "@/proxies/back-end/payment-request/update";
import addNewShareholder from "@/proxies/back-end/workflow/add-new-shareholder/add-new-shareholder";
import GetCompanyProxy from "@/proxies/back-end/company/get";
import GetInvoices from "@/proxies/back-end/invoices/get";
import GetPaymentRequestByTokenProxy from "@/proxies/back-end/payment-request/get";

// Components
import PaymentMenuContentSummary from "./PaymentMenuContentSummary.vue";
import PaymentMethodSelect from "./PaymentMenuContentPaymentMethod.vue";
import CopyComponent from "./mini-components/CopyComponent.vue";
import DatePicker from "@shared-components/presentational/DatePicker.vue";

// Mapping
import GlobalTopic from "@/utilities/global-topic";
import LocalStoreManager from "@/utilities/local-store-manager";
import ShoppingCartManager from "@/utilities/shopping-cart-manager";
import {getAppFeatureProp} from "@/utilities/app-feature-util";

// Mixins
import { GoogleAnalyticsMixin } from "@/mixins/googleAnalytics";
import { ConfigMixin } from "@/mixins/config-mixin";

import { handleTask } from "@/utilities/workflow-task-handler";
import { Constants } from "customer-sdk/constants";

const { WORKFLOW_CONSTANTS } = Constants.WORK_FLOW;
const PAGE_URLS = Constants.PAGE_URLS;
const PAYMENT_METHODS_EVENTS = Constants.ON_BOARDING_PAYMENT_METHODS_EVENTS;
const ON_BOARDING_EVENTS = Constants.ON_BOARDING_EVENTS;
const { COMPANY_USER_MODULE, COMPANY_USERS } = Constants.COMPANY_USERS_CONSTANTS;
const EVENTS = Constants.EVENTS;
const ERROR_MESSAGES = Constants.ERROR_MESSAGES;

import { get, pickBy, isEmpty } from "lodash";

//#region private variables
let POST_PAYMENT_PATH = "/processing-payment";
let NEW_POST_PAYMENT_PATH = PAGE_URLS.INCORPORATION;
let INVALID_DATE_INPUT = "expected_pay_at: Invalid date";
let store = new LocalStoreManager();
//#endregion

//#region private methods
let renderIssueMessage = (message, timeout) => {
  GlobalTopic.publishChange({
    type: EVENTS.ON_OPEN_SNACKBAR,
    data: {
      snackbarText: message,
      timeout: timeout
    }
  });
};

let getPostPaymentPage = (component) => {
  if (component.useNewPostRenewalPage && component.paymentMethodSelected === 'pay_now') {
    return PAGE_URLS.POST_RENEWAL_SUBSCRIPTION;
  }

  return PAGE_URLS.POST_RENEWAL_PAYMENT;
}

const getPaymentData = async component => {
  const paymentData = JSON.parse(JSON.stringify(component.defaultPaymentData));
  const paymentAuthToken = component.$route.query.authToken;
  //get company id from payment request instead of current company
  //this piece of if below is created to resolve problem:
  //admin create payment request for company A
  //user currently login to company B and make a payment for company A
  if (paymentAuthToken) {
    const proxy = new GetPaymentRequestByTokenProxy();
    const input = {
      token: paymentAuthToken,
      authToken: component.defaultPaymentData.authToken,
      loggedInUser: store.getUserId()
    };
    const data = await proxy.get(input);
    paymentData.id = data.company._id;
  }

  return paymentData;
}

/**
 * Handle event where user presses I've made my payment
 */
let handleApplyForManualPayment = async component => {
  const getInvoiceProxy = new GetInvoices();
  const paymentData = await getPaymentData(component);
  
  component.invoice = await getInvoiceProxy.getCompanyInvoice(paymentData, {
    invoice_tag: component.entryPoint,
    status: 'done'
  });

  try {
    let { subscriptionIds } = component;

    if (subscriptionIds && subscriptionIds.length > 0 && !component.requestPaymentId) {
      if(component.invoice && component.invoice.status === "done") {
        component.$router.push(getPostPaymentPage(component));
        return;
      }
       /*
       * Payment entry points 
       * ['Manual Renewal']
       */
      const paymentData = await handleSubscriptionManualPayment(component);
      if (component.task) {
        try {
          await handleTask(component.task, paymentData, WORKFLOW_CONSTANTS.PAYMENT_STATUS.PENDING);
        } catch (error) {
          console.log("error", error);
        }
      } else {
        if (component.isPartnerBillingProfilePayment) {
          component.$emit("displayAfterPaymentScreen", { paymentMethod: "manualPayment" });
        } else {
          component.$router.push(getPostPaymentPage(component));
        }
      }
      return;
    } else if (
      component.requestPaymentId ||
      (subscriptionIds && subscriptionIds.length === 0 && component.oneOffCodes)
    ) {
     
      /*
       * Payment entry points 
       * ['Payment Request, Onboarding Accounting Setup']
       */
      if(component.invoice && component.invoice.status !== "done") {
        await handleOneOffManualPaymentFromPaymentRequest(component);

        if (component.requestPaymentId) {
          let proxy = new UpdatePaymentRequestByTokenProxy();

          const request_payment_status = getAppFeatureProp(component.platformConfig.cmsGeneralFeatureList, "request_payment_status");

          await proxy.updateRecord(component.defaultPaymentData, {
            paymentRequestId: component.requestPaymentId,
            status: request_payment_status.value.USED
          });
        }
      }

      if (component.accountingSetupOptions) {
        const { redirect, openedPage, questionnaire_token, email } = component.accountingSetupOptions;
        await component.updateQuestionnaireMultiCurrency(openedPage);
        const urlParams = new URLSearchParams(pickBy({ redirect, openedPage, questionnaire_token, email }));
        component.$router.push(`${getPostPaymentPage(component)}?${urlParams}`);
      } else {
        component.$router.push(`${PAGE_URLS.POST_PAYMENT_REQUEST}`);
      }
    } else if (component.upgradeCorpSecSubscription) {
       if(component.invoice && component.invoice.status === "done") {
          component.$router.push(`${PAGE_URLS.ON_GOING_REQUEST}`);
          return;
      }
      const companyUsers = component.$store.getters[`${COMPANY_USER_MODULE}/${COMPANY_USERS}`];
      let paymentData = await handleUpgradeCorpSecSubscriptionManualPayment(component);
      try {
        await handleTask(component.task, paymentData, WORKFLOW_CONSTANTS.PAYMENT_STATUS.PENDING, companyUsers);
      } catch (error) {
        console.log("error", error);
      }
    } else if (!isEmpty(component.unpaidBillsDetails)) {
      try {
         if(component.invoice && component.invoice.status === "done") {
           component.$router.push(
            `${getPostPaymentPage(component)}`
          );
          return;
         }
        let paymentData = await handleUnpaidBillManualPayment(component);
        component.$router.push(
            `${getPostPaymentPage(component)}`
          );
      } catch (error) {
        console.log("error", error);
      }
    }else if (component.addShareholderId) {
      if(component.invoice && component.invoice.status === "done") {
          component.$router.push(`${PAGE_URLS.POST_REQUEST_SHAREHOLDER}?paidWith=bank`);
          return;
      }
      let paymentData = await handleShareholderManualPayment(component);
      component.parseGAData(paymentData);
      component.$router.push(`${PAGE_URLS.POST_REQUEST_SHAREHOLDER}?paidWith=bank`);
    } else if (component.isPartnerPayment) {
      /*
       * Payment entry points 
       * ['Partner App Onboarding']
       */
      await handleOnboardingManualPayment(component);
      publishPaymentSubmitted(component);
    } else {
       /*
       * Payment entry points 
       * [Customer App Onboarding, 'Unpaid Bill']
       */
      await handleOnboardingManualPayment(component);

      const new_dashboard_onboarding_enabled = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "new_dashboard_onboarding_enabled");

      const isNewUiEnabled = new_dashboard_onboarding_enabled.enabled;
      const new_payment_page_enabled = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "new_payment_page_enabled");

      const isNewPaymentPage = new_payment_page_enabled.enabled || false;
      if (isNewUiEnabled) {
        if (isNewPaymentPage) {
          component.$store.dispatch("companyUsersModule/hideShoppingCartAfterPayment");
          component.$store.dispatch("companyUsersModule/hideShoppingCartDropdown");
          component.$emit("displayAfterPaymentScreen", { paymentMethod: "manualPayment" });
        } else {
          component.$router.push(`${NEW_POST_PAYMENT_PATH}?isInitial=true`);
        }
      } else {
        component.$router.push(`${POST_PAYMENT_PATH}?isInitial=true`);
      }
    }
  } catch (error) {
    if (error.message == INVALID_DATE_INPUT) {
      publishSubmitPaymentError(component, ERROR_MESSAGES.MANUAL_PAYMENT.INVALID_PAYMENT_DATE_INPUT);
    }

    throw error;
  }
};

let handleOnboardingManualPayment = async component => {
  try {
    let proxy = new ApplyForManualPaymentProxy();
    let payload = {
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber,
      invoice_only: true,
      invoice_tag: store.getPaymentEntryPoint()
    };
    return await proxy.execute(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let handleSubscriptionManualPayment = async component => {
  try {
    let proxy = new ApplyForSubscriptionManualPaymentProxy();
    let payload = {
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber,
      companySubscriptionIds: component.subscriptionIds,
      isPartnerBillingProfilePayment: component.isPartnerBillingProfilePayment,
      invoice_tag: store.getPaymentEntryPoint()
    };
    return await proxy.execute(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let handleUpgradeCorpSecSubscriptionManualPayment = async component => {
  const proxy = new AllTypePaymentPostProxy();
  const companyId = component.defaultPaymentData.id;
  const invoiceNumber = get(component, "invoice.number");
  const amendCompanyShareStructureData = localStorage.getItem(`amendCompanyShareStructureData_${companyId}`);
  const shareholders = get(JSON.parse(amendCompanyShareStructureData), "shareholders", []);
  const totalNumberOfShareholder = shareholders.filter(shareholder => !shareholder.is_removed).length;

  try {
    const payload = {
      company_id: companyId,
      total_number_of_shareholder: totalNumberOfShareholder,
      invoice_tag: store.getPaymentEntryPoint(),
      invoice_number: invoiceNumber,
    };
    return await proxy.upgradeCorpSecSubscriptionManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    initCreatePaymentToken(component);
    throw error;
  }
};

let handleOneOffManualPaymentFromPaymentRequest = async component => {
  try {
    let proxy = new AllTypePaymentPostProxy();
    let payload = {
      companySubscriptionIds: component.subscriptionIds,
      oneOffCodes: component.oneOffCodes,
      companyId: localStorage.getItem("paymentRequestCompanyId")
        ? localStorage.getItem("paymentRequestCompanyId")
        : localStorage.getItem("companyId"),
      requestPaymentId: component.requestPaymentId,
      requestPaymentItems: component.requestPaymentItems,
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber,
      invoice_tag: store.getPaymentEntryPoint()
    };
    return await proxy.postManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

const handleUnpaidBillManualPayment = async component => {
  const proxy = new AllTypePaymentPostProxy();
  const company_id = component.defaultPaymentData.id;
  try {
    let payload = {
      company_id,
      unpaidBillsDetails: component.unpaidBillsDetails
    };

    return await proxy.unpaidBillManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    initCreatePaymentToken(component);
    throw error;
  }
};

let buildPayload = async component => {
  const cart = new ShoppingCartManager();
  let response = await cart.fetchUpgradeCorpsecSubscriptionDetails(component.addShareholderId);
  let companyProxy = new GetCompanyProxy();
  let company = await companyProxy.execute({ id: await store.getCompanyId(), authToken: store.getToken() });

  const companyId =
    localStorage.getItem("paymentRequestCompanyId") && localStorage.getItem("paymentRequestCompanyId") != "null"
      ? localStorage.getItem("paymentRequestCompanyId")
      : localStorage.getItem("companyId");
  const payload = {
    authToken: store.getToken(),
    payload: {
      requested_by_user_id: store.getUserId(),
      requested_by_user_name: store.getUserEmail(),
      company_user_id: store.getUserId(),
      company_user_name: store.getUserEmail(),
      company_id: companyId,
      company_name: company ? company.name : "",
      price: response ? response.shoppingCartTotal : 0,
      company_workflow_data: {
        request_information: {
          request_type: "addition_of_shareholder",
          company_id: companyId,
          company_name: company ? company.name : "",
          requested_by_user_id: store.getUserId()
        }
      }
    }
  };
  return payload;
};

let handleShareholderManualPayment = async component => {
  try {
    let proxy = new AllTypePaymentPostProxy();
    let payload = {
      addShareholderId: component.addShareholderId,
      companyId: localStorage.getItem("paymentRequestCompanyId")
        ? localStorage.getItem("paymentRequestCompanyId")
        : localStorage.getItem("companyId"),
      expected_pay_at: component.form.dateOfPayment,
      cheque_number: component.form.chequeNumber,
      invoice_tag: store.getPaymentEntryPoint()
    };
    // start workflow
    let workflowPayload = await buildPayload(component);
    await addNewShareholder.startAdditionOfShareholder(workflowPayload);

    return await proxy.postUpgradeManualPayment(component.defaultPaymentData, payload);
  } catch (error) {
    throw error;
  }
};

let publishSubmitPaymentError = (component, message) => {
  let { paymentMethodsTopic } = component;
  if (paymentMethodsTopic) {
    paymentMethodsTopic.publish({
      type: PAYMENT_METHODS_EVENTS.ON_SUBMIT_PAYMENT_ERROR,
      data: message
    });
  }
};

// let subscribeToTopic = (component) => {
// 	if (component.paymentMethodsTopic) {
// 		component.paymentMethodsTopic.subscribe((msg) => {
// 			if (msg.type === PAYMENT_METHODS_EVENTS.ON_EXISTING_CARD_SELECTED) {
// 				component.isVisible = false;
// 			} else if (msg.type === PAYMENT_METHODS_EVENTS.ON_ADD_NEW_CARD_SELECTED) {
// 				component.isVisible = false;
// 			} else if (msg.type === PAYMENT_METHODS_EVENTS.ON_BANK_TRANSFER_CLICKED) {
// 				component.isVisible = true;
// 			}
// 		});
// 	}
// };

let getComponentData = component => {
  return {
    lastDoneStep: 4
  };
};

let publishPaymentSubmitted = component => {
  if (component.onBoardingTopic) {
    component.onBoardingTopic.publish({
      type: ON_BOARDING_EVENTS.ON_PAYMENT_SUBMITTED,
      data: getComponentData(component)
    });
  }
};
//#endregion

export default {
  components: {
    PaymentMenuContentSummary,
    DatePicker,
    PaymentMethodSelect,
    CopyComponent
  },
  mixins: [GoogleAnalyticsMixin, ConfigMixin],
  props: {
    onBoardingTopic: Object,
    paymentMethodsTopic: Object,
    defaultPaymentData: Object,
    paymentMethodSelected: String,
    subscriptionIds: Array,
    unpaidBillsDetails: Array,
    task: Object,
    oneOffCodes: Array,
    requestPaymentId: String,
    requestPaymentItems: Array,
    isPartnerPayment: Boolean,
    addShareholderId: String,
    promoCodeEnabled: Boolean,
    accountingSetupOptions: Object,
    updateQuestionnaireMultiCurrency: Function,
    isPartnerBillingProfilePayment: {
      type: Boolean,
      default: false
    },
    upgradeCorpSecSubscription: { type: Boolean, default: false },
    companyIdFromBillingProfile: String,
    invoice: Object,
    shoppingCartTotal: Number,
    entryPoint: String
  },
  computed: {
    bankDetails() {
      const ms_banking_details = getAppFeatureProp(this.platformConfig.cmsGeneralFeatureList, "ms_banking_details");
      const sleek_banking_details = getAppFeatureProp(this.platformConfig.cmsGeneralFeatureList, "sleek_banking_details");
      
      return this.platformConfig && this.isPartnerBillingProfilePayment
        ? ms_banking_details.value
        : sleek_banking_details.value;
    },
    hasBackButtonListener() {
      return this.$parent.$listeners && this.$parent.$listeners.triggerBackButton instanceof Function;
    },
    amountToTransfer(){

      let total = 0;

      if(!this.requestPaymentItems || this.requestPaymentItems.length === 0) return this.shoppingCartTotal;

      this.requestPaymentItems.map(item=>{

        total+=item.service_unit_price * item.quantity

      })

      return total;
    }
  },
  data() {
    const defaultForm = Object.freeze({
      dateOfPayment: "",
      chequeNumber: ""
    });
    return {
      form: Object.assign({}, defaultForm),
      isVisible: false,
      defaultForm,
      isButtonLoading: false,
      paynowEnabled: true,
      show_supported_banks:false,
      useNewPostRenewalPage: false,
      currency: {},
    };
  },
  methods: {

    showSupportedBanks: function() {
      this.show_supported_banks = !this.show_supported_banks
    },
    onBackEvent: function() {
      // this.$parent.$emit("triggerBackButton");
    },
    onBackClick: function(onBoardingTopic) {
      if (onBoardingTopic) {
        onBoardingTopic.publish({
          type: ON_BOARDING_EVENTS.ON_CONTACT_SELECTED
        });
      }
    },
    onClickSubmitPayment: async function() {
      let component = this;
      try {
        component.isButtonLoading = true;
        await handleApplyForManualPayment(component);
      } catch (error) {
        component.isButtonLoading = false;
        renderIssueMessage(error.message, 3000);
        throw error;
      }
    },
    onUpdateDateFormField: function(event) {
      const component = this;
      component.form.dateOfPayment = event;
    }

  },
  async created() {},
  async mounted() {
    const component = this;

    

    const new_dashboard_post_incorporation = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "onboarding");
    const revamped_design= getAppFeatureProp(new_dashboard_post_incorporation.props, "revamped_design");
    const paynow_enabled= getAppFeatureProp(revamped_design.props, "paynow_enabled");

    const billingSettings = getAppFeatureProp(component.platformConfig.cmsAppFeatures, "billing_settings");
    const new_ui_inactive_service = getAppFeatureProp(billingSettings.props, "new_ui_inactive_service");
    const newUIInactiveValue = new_ui_inactive_service.enabled && new_ui_inactive_service.value || {};

    component.useNewPostRenewalPage = newUIInactiveValue.newPostRenewalPage;
    component.paynowEnabled = paynow_enabled.enabled;
    component.currency = component.platformConfig.currency;
  }
};
</script>